<template>
  <main id="main-content" class="flex-display-body container py-5">
    <div class="row">
      <div class="col-12">
        <h1 class="display-4 pb-3">Help</h1>

        <p>The Enterprise Directory Group Manager tool is used to create and manage
          groups in the VT EnterPrise Directory (ED).
          <br>
          The following links on the Middleware website provide further information about ED groups in general.
        </p>

        <ul>
          <li class="pb-2">
            <a href="https://www.middleware.vt.edu/ed/groups/"
               target="_blank"
               rel="noopener noreferrer nofollow">
              General Documentation
              <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
            </a>
          </li>
          <li class="pb-2">
            <a href="https://www.middleware.vt.edu/ed/groups/#ougroupsdcvtdcedu"
               target="_blank"
               rel="noopener noreferrer nofollow">
              Roles and other terms
              <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
            </a>
          </li>
        </ul>

        <p>
          The VT 4Help Knowledge Base also has a few articles:
        </p>

        <ul>
          <li class="pb-2">
            <a href="https://vt4help.service-now.com/sp?id=kb_article&sys_id=87274306db7f2600e3a0f839af9619d1"
               target="_blank"
               rel="noopener noreferrer nofollow">
              Groups Overview
              <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
            </a>
          </li>
          <li class="pb-2">
            <a href="https://vt4help.service-now.com/sp?id=sc_cat_item&sys_id=0d029a530fee9b00e42e4b9ce1050ebc"
               target="_blank"
               rel="noopener noreferrer nofollow">
              Initial Group Prefix Request
              <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
            </a>
          </li>
        </ul>

        <h2>Namespaces</h2>
        <p>The dotted nomenclature of group names is primarily used to control group
        namespaces.  Although group names bear a resemblance to inverted DNS names,
        they are not necessarily hierarchical.
          <br><br>
          For example, the group
        "middleware.staff" is not, by default, a member of the group "middleware".
        The name "middleware.staff" may suggest to some users that it is automatically
        a member of the "middleware" group, but this is neither required nor the default
        setting.
          <br><br>
          If that is confusing, it may be helpful to manually create
        parent-child relationships among groups to create the hierarchy suggested by
        the name.</p>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  title: 'Help',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Help.vue